import script from "./PlanLive.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanLive.vue?vue&type=script&setup=true&lang=js"

import "./PlanLive.vue?vue&type=style&index=0&id=a00d113c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a00d113c"]])

export default __exports__